import React, { type FC } from "react";
import {
  SystemModalCloseIcon,
  SystemModalHeader,
} from "@edreamsodigeo/prisma-design-system";

import { type GoBackHeaderProps } from "./contract";
import GoBackHeaderContent from "./GoBackHeaderContent";

const sx = {
  background: "linear-gradient(135deg, #DA3835 0%, #F9700D 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  minHeight: "0px",
  height: "0px",
};

const GoBackHeader: FC<GoBackHeaderProps> = ({
  onGoBack,
  screen,
  trackingPrefix,
}) => (
  <SystemModalHeader type="critical" sx={sx}>
    <SystemModalCloseIcon onClose={onGoBack}>
      <GoBackHeaderContent screen={screen} trackingPrefix={trackingPrefix} />
    </SystemModalCloseIcon>
  </SystemModalHeader>
);

export default GoBackHeader;
